import React from "react";
import styled from "styled-components";
import { FontSize } from "@themes/Fonts";
import HostPillIndicator from "./components/HostPillIndicator";

const DisplayName = styled.span<{ isBold: boolean }>`
    font-size: ${FontSize.normal};
    color: ${(props) => props.theme.textColorPrimary};
    font-weight: ${(props) => (props.isBold ? `550` : `500`)};

    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
`;

const RoomMemberDisplayNameContainer = styled.div`
    display: flex;
    align-items: center;
    overflow: hidden;
    gap: 5px;
`;

interface RoomDisplayNameProps {
    readonly displayName: string | undefined;
    readonly isDisplayNameBold: boolean;
    readonly isHost: boolean;
    readonly className?: string;
}
export default function RoomMemberDisplayName(props: RoomDisplayNameProps) {
    return (
        <RoomMemberDisplayNameContainer>
            <DisplayName className={`display-name ${props.className}`} isBold={props.isDisplayNameBold}>
                {props.displayName ?? "User"}
            </DisplayName>
            {props.isHost && <HostPillIndicator />}
        </RoomMemberDisplayNameContainer>
    );
}
